import { render, staticRenderFns } from "./ConfigureVersion.vue?vue&type=template&id=678220ea"
import script from "./ConfigureVersion.vue?vue&type=script&lang=js"
export * from "./ConfigureVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports